var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 16,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 0C9.74546 0 9.94961 0.176875 9.99194 0.410124L10 0.5V1H13.25C13.6642 1 14 1.33579 14 1.75V11.25C14 11.6642 13.6642 12 13.25 12H0.75C0.335786 12 0 11.6642 0 11.25V1.75C0 1.33579 0.335786 1 0.75 1H4V0.5C4 0.223858 4.22386 0 4.5 0C4.74546 0 4.94961 0.176875 4.99194 0.410124L5 0.5V1H9V0.5C9 0.223858 9.22386 0 9.5 0ZM13 5H1V11H13V5ZM11.5 7V9H9.5V7H11.5ZM4 2H1V4H13V2H10V2.5C10 2.77614 9.77614 3 9.5 3C9.25454 3 9.05039 2.82312 9.00806 2.58988L9 2.5V2H5V2.5C5 2.77614 4.77614 3 4.5 3C4.25454 3 4.05039 2.82312 4.00806 2.58988L4 2.5V2Z",
    fill: "#74767C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLight);
export default __webpack_public_path__ + "static/media/CalendarLight.13a18bcca6318cd337cbc044bbb12da1.svg";
export { ForwardRef as ReactComponent };